module.exports = __webpack_public_path__ + "img/ECOSHOP.701220d6.svg";